import { useMemo } from 'react';

export const DEFAULT_BRANDING_COLORS = {
  color_button: '#4E18BB',
  color_button_text: '#FFF',
  color_link: '#4E18BB',
};

export const applyDefaultBrandingColors = values => ({
  ...values,
  color_button: values.color_button || DEFAULT_BRANDING_COLORS.color_button,
  color_button_text: values.color_button_text || DEFAULT_BRANDING_COLORS.color_button_text,
  color_link: values.color_link || DEFAULT_BRANDING_COLORS.color_link,
});

export const useBrandingStyleVariables = brand => {
  return useMemo(() => {
    if (!brand) {
      return {
        '--button-color': DEFAULT_BRANDING_COLORS.color_button,
        '--button-text-color': DEFAULT_BRANDING_COLORS.color_button_text,
        '--link-color': DEFAULT_BRANDING_COLORS.color_link,
      };
    }

    return {
      '--button-color': brand.color_button || DEFAULT_BRANDING_COLORS.color_button,
      '--button-text-color': brand.color_button_text || DEFAULT_BRANDING_COLORS.color_button_text,
      '--link-color': brand.color_link || DEFAULT_BRANDING_COLORS.color_link,
    };
  }, [brand]);
};
